<style lang="scss">
.post-details {
  b {
    display: block;
  }
}
</style>

<!-- eslint-disable -->
<template>
  <article class="post-details">
    <section v-if="!loading">
      <b-card>
        <div class="row">
          <section class="col-4">
            <h4>Sentiment</h4>
            <p cy="analysis-rating"><b>Sentiment rating</b> {{analysis.sentiment}}</p>

            <p class="mb-0"><b>Sentiment score</b></p>
            <div class="d-inline-flex justify-content-between full-width">
              <p cy="analysis-mixed"><b>Mixed</b> {{scoreToPercent(analysis.sentiment_score.mixed)}}%</p>
              <p cy="analysis-negative"><b>Negative</b> {{scoreToPercent(analysis.sentiment_score.negative)}}%</p>
              <p cy="analysis-neutral"><b>Neutral</b> {{scoreToPercent(analysis.sentiment_score.neutral)}}%</p>
              <p cy="analysis-positive"><b>Postive</b> {{scoreToPercent(analysis.sentiment_score.positive)}}%</p>
            </div>
          </section>

          <section class="col-4">
            <h4>Detected Languages</h4>

            <div v-for="lang in analysis.languages">
              <p cy="lang-score"><b>{{getCountryNameFromCode(lang.language_code)}}</b> {{scoreToPercent(lang.score)}}% confident</p>
            </div>
          </section>

          <section class="col-4">
            <h4>Post Translation</h4>

            <p v-if="translations.length === 0">No Translations to show</p>

            <div v-else>
              <p :class="{'fake-link': message !== item.translated_message}" @click="setPostcardMessage(item.translated_message)"
                 v-for="item in translations" :key="item._id">Show in {{getCountryNameFromCode(item.translated_language)}}</p>
              <p :class="{'fake-link': message !== post.message}" @click="setPostcardMessage(post.message)">Show original content</p>
            </div>

            <b-button v-if="showTranslateBtn"
                      :class="{'disabled': loadingTranslation}" variant="success" @click="translatePost()">Translate Post</b-button>
          </section>
        </div>
      </b-card>

      <b-card>
        <div class="row">
          <section class="col-12">
            <h4>Keywords & phrases found</h4>
            <small v-if="analysis.keyword_alerts.length > 0" class="d-inline-block mb-1">Click text to highlight on post</small>

            <div v-for="alert in getUniqueKeywordsForAnalysis(analysis.keyword_alerts)" class="p-1" :class="{'highlight': isHighlighted(alert.word)}">
              <p @click="setHightlightedPhrase(alert.word, post.message)" class="pointer mb-0">
                <b cy="analysis-keyword">{{alert.word}}</b>
              </p>
            </div>

            <p v-if="analysis.keyword_alerts.length === 0">No Keywords found to cause concern</p>
          </section>
        </div>

        <div class="row" v-if="translationAnalysis">
          <section class="col-12" v-for="(item, index) in translationAnalysis" :key="item._id">
            <h4>Keywords & phrases found for translated language {{getCountryNameFromCode(item.translated_language)}}</h4>
            <small v-if="translationAnalysis.keyword_alerts && translationAnalysis.keyword_alerts.length > 0" class="d-inline-block mb-1">
              Click text to highlight on post in this language
            </small>

            <div v-for="alert in getUniqueKeywordsForAnalysis(item.keyword_alerts)" class="p-1" :class="{'highlight': isHighlighted(alert.word)}">
              <p @click="setHightlightedPhrase(alert.word, translations[index].translated_message)" class="pointer mb-0">
                <b>{{alert.word}}</b>
              </p>
            </div>

            <p v-if="item.keyword_alerts.length === 0">No Keywords found to cause concern</p>
          </section>
        </div>
      </b-card>

    </section>

    <section v-else>
      <b-spinner variant="primary" label="Loading post"></b-spinner>
    </section>
  </article>
</template>
<!-- eslint-enable -->

<script>
import { mapState } from 'vuex';
import DigitalRepliesService from '@/services/DigitalRepliesService';
import KeywordsService from '../../../services/KeywordsService';
import TranslationService from '../../../services/TranslationService';
import Countries from '../../../components/country/countryCodes.json';

export default {
  components: {},
  props: {
    post: {
      required: true,
      type: Object,
    },
    isReply: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      loading: true,
      analysis: null,
      showTranslateBtn: false,
      translations: [],
      translationAnalysis: null,
      loadingTranslation: false,
    };
  },
  computed: {
    ...mapState({
      highlightedPhrase: state => state.postCard.highlightedPhrase,
      message: state => state.postCard.postcardMessage,
    }),
  },
  mounted() {
    this.getPostAnalysis();
  },
  methods: {
    getPostAnalysis() {
      this.loading = true;

      KeywordsService.getPostAnalysis(this.post._id).then(res => {
        // console.log('got analysis', res);
        this.analysis = res.data;
        this.$store.commit('postCard/SET_ANALYSIS', this.analysis);
        this.manageTranslations(this.analysis.languages);
      }).catch(err => {
        console.log('could not get post analysis', err);
        this.$toast.error('Could not get post analysis, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    scoreToPercent(score) {
      return ((score / 1) * 100).toFixed(2);
    },
    setHightlightedPhrase(phrase, message) {
      this.setPostcardMessage(message);
      this.$store.commit('postCard/SET_HIGHLIGHTED_PHRASE', phrase);
    },
    isHighlighted(phrase) {
      return phrase === this.highlightedPhrase;
    },
    manageTranslations(languages) {
      let differentLang = false;
      const foreignLanguages = [];

      if (languages) {
        languages.forEach(lang => {
          if (lang.language_code !== 'en') {
            const score = this.scoreToPercent(lang.score);
            if (score >= 60) {
              differentLang = true;
            }

            // Add any found foreign languages
            foreignLanguages.push(lang);
          }
        })
      }

      if (differentLang) {
        this.getExistingTranslations();
      }

      // Push list regardless to update in the store
      this.$store.commit('postCard/SET_FOREIGN_LANGUAGES', foreignLanguages);
    },
    getExistingTranslations() {
      TranslationService.getExistingTranslations(this.post._id).then(res => {
        if (!res.data || res.data.length === 0) {
          this.showTranslateBtn = true;
        } else {
          this.translations = res.data;
          this.getPostAnalysisForTranslation();
        }
      }).catch(err => {
        console.log('could not get post translation', err);
        this.$toast.error('Could not get post translation, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }).finally(() => {
        this.loadingTranslation = false;
      });
    },
    translatePost() {
      this.loadingTranslation = true;

      const promises = [];

      if (this.isReply) {
        promises.push(DigitalRepliesService.translatePost(this.post._id));
      } else {
        promises.push(TranslationService.translatePost(this.post._id));
      }

      Promise.all(promises).then(result => {
        const res = result[0];
        this.showTranslateBtn = false; // hide the translate button
        this.translations = [res.data.translation];
        this.translationAnalysis = [res.data.analysis];
      }).catch(err => {
        console.log('could not get post translation', err);
        this.$toast.error('Could not get post translation, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }).finally(() => {
        this.loadingTranslation = false;
      });
    },
    getPostAnalysisForTranslation() {
      TranslationService.getTranslationAnalysisForPost(this.post._id).then(res => {
        this.translationAnalysis = res.data;
      }).catch(err => {
        console.log('could not get post analysis', err);
        this.$toast.error('Could not get post analysis, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    setPostcardMessage(message) {
      this.$store.commit('postCard/SET_HIGHLIGHTED_PHRASE', ''); // remove any existing highlights
      this.$store.commit('postCard/SET_ACTIVE_MESSAGE', message);
    },
    getCountryNameFromCode(code) {
      const country = Countries.find(item => item.code.toLowerCase() === code.toLowerCase());
      return country ? country.name : code;
    },
    getUniqueKeywordsForAnalysis(alerts) {
      const filtered = [];

      alerts.forEach(alert => {
        const exists = filtered.find(item => item.word === alert.word);

        if (!exists) {
          filtered.push(alert);
        }
      });

      return filtered;
    },
  },
};
</script>
